<template>
    <div>
        <div class="d-flex"
             :style="'width: ' + horizontal ? 'max-content' : '100%'"
             :class="horizontal ? 'flex-row' : 'flex-column'">
            <div class="font-weight-bold text-left key" style="color: #878787">
                <slot></slot>
            </div>
            <div class="font-weight-bold values"
                 :class="(horizontal ? 'ml-1' : '') + (inlineView ? ' inline-view' : '')">
                <slot v-if="customValue" name="value"></slot>
                <router-link :to="routerLink" v-else-if="routerLink != null">
                    {{ viewValue }}
                </router-link>
                <span v-else
                      :class="clickAble ? 'cursor-pointer badge badge-pill badge-secondary' : ''"
                      @click="whenClick">
                    {{ viewValue }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: ""
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        routerLink: {
            type: String,
            default: null
        },
        clickAble: {
            type: Boolean,
            default: false
        },
        lengthLimit: {
            type: Number,
            default: -1
        },
        inlineView: {
            type: Boolean,
            default: false
        },
        customValue: {
            type: Boolean,
            default: false
        }
    },
    name: "KeyValueCell",
    computed: {
        viewValue() {
            if (this.lengthLimit > -1) {
                let temp = this.value + "";
                return temp.substring(0, this.lengthLimit) + (temp.length > this.lengthLimit ? '...' : '');
            } else return this.value;
        }
    },
    methods: {
        whenClick() {
            if (this.clickAble) {
                this.$emit('valueClick')
            }
        }
    }
}
</script>

<style scoped>
.key {
    white-space: nowrap;
}

.values {
    font-size: 0.8rem;
    color: #5f5f5f;
    word-break: break-all;
    text-align: left;
}

.inline-view {
    width: max-content !important;
}
</style>
